var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD16LinkBlock = function SvgD16LinkBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-16-link-block_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d-16-link-block_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.097 2.88a3.017 3.017 0 0 0-4.252 0L6.549 5.176a3.44 3.44 0 0 1 2.387.182l1.193-1.194a1.19 1.19 0 0 1 1.683 1.683l-1.5 1.5-.987.987a1.19 1.19 0 0 1-1.682 0L6.358 9.619a2.93 2.93 0 0 0 1.011.663 3.033 3.033 0 0 0 3.242-.663l1.55-1.55.936-.937a3.002 3.002 0 0 0 0-4.252z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.988 10.671-1.144 1.144a1.19 1.19 0 0 1-1.683-1.683l2.487-2.486a1.19 1.19 0 0 1 1.683 0L9.615 6.36a3.014 3.014 0 0 0-4.136-.108c-.041.033-.083.075-.116.108L2.877 8.848a3.017 3.017 0 0 0 0 4.252 3.017 3.017 0 0 0 4.252 0l2.246-2.271c-1.144.265-1.409.232-2.387-.158z"
  })))));
};
export default SvgD16LinkBlock;